import LazyLoad from "react-lazyload"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"

const SpocmacyColtoralHeritage = () => {
    const homeMenu = [
        { label: "MUN", link: "/Mun" },
        { label: "Glory to the Nation", link: "/GloryOfNation" },
        { label: "Spic Macay Cultural and Heritage Club", link: "/SpocmacyColtoralHeritage" },
        { label: "Vocational Education Clubs (Middle Wing) ", link: "/vocationalClubmiddle" },
        { label: "Vocational Education Clubs (Senior Wing)", link: "/vocationalClub" },
        { label: "Vocational Education Clubs (Primary Wing)", link: "/VocationalClubPrimary" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/blog-banner.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Spic Macay Cultural and Heritage Club" breadEnd="Spic Macay Cultural and Heritage Club" breadMid="Spic Macay Cultural and Heritage Club" />
                        </div>
                    </div> 
                    <div className="row">
                        <div className="col-lg-12">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/IMG-20220209-WA0006.jpg" className="img-fluid wid-100 mb-4" alt="Lotus Valley School, Gurgaon" /></LazyLoad> 
                            <h4>Upcoming Event</h4>
                            <p>Lotus Drishti2022: The Perspective is one of the foremost efforts by LVISG for its sustained promotion and propagation of Art integrated approach to learning. Drishti provides opportunities for innovation and creativity in all its training as well as performing activities.</p>
                            <p>The objective is to create more art-lovers for perpetuation of art in society. The mission of Drishti is not only to inspire artists and art lovers, but also to popularize art integrated learning among common people.This event gives provides and creates a platform to observe , decipher: critically and analytically ; create and express: views and opinions , developing new perspectives through the medium of art bringing an all new insight to the already known facts, events and data.</p>
                            <p>We look forward to welcoming all to create masterpieces and bring new insights and perspectives in the learning process. Through the events, we aim to empower the learners to learn the world of Humanities and unleash their creative genius and inspire us all .</p>
                        </div>
                    </div>

</div>
                </div>
                <Footer />
            </>
            )
}
            export default SpocmacyColtoralHeritage